import { createRoutine } from "redux-saga-routines";
import ActionTypes from "./constants";

export const gtm = createRoutine(ActionTypes.GTM);

export const track = createRoutine(ActionTypes.TRACK_SUCCESS);

export default {};
